<script setup lang="ts">
import { SbListItem, SbListLabel, SbListSection } from "@unio/saltbox-ui"

import { ICON } from "@/lib/icons"

defineProps<{
  icon: string
  label: string
  caption: string
  to: string
}>()
</script>

<template>
  <SbListItem :to="to">
    <SbListSection avatar>
      <UIcon :name="icon" class="text-muted size-5" />
    </SbListSection>
    <SbListSection>
      <SbListLabel>{{ label }}</SbListLabel>
      <SbListLabel caption>{{ caption }}</SbListLabel>
    </SbListSection>
    <SbListSection side>
      <slot name="trailing" />
      <UIcon :name="ICON.chevronRight" class="size-4" />
    </SbListSection>
  </SbListItem>
</template>
